<template>
    <div>
        <div v-for="pool in list" :key="pool.name">
            <b>{{ pool.name }}</b>
            <span>{{ pool.amount | currency }}</span>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: ['gameId'],

    computed: {
        ...mapState(['pools']),

        list() {
            const pools = Config.games[this.gameId].pools;

            const list = [];

            for (const [ poolId, { name } ] of Object.entries(pools)) {
                list.push({ name, amount: this.pools[poolId] });
            }

            return list;
        },
    },
}
</script>